export default {
  computed: {
    btcState() {
      return this.$router.currentRoute.query.next || +new Date();  // return a unix timestamp
    },
    btcClientId() {
      return this.$store.getters.appConfig.btc.clientId;
    },
    btcLoginVVBase() {
      return document.location.origin + '/btc/sign-in';
    },
    btcLogin() {
      return `https://pubapi.bigtincan.com/services/oauth2/authorize?access_type=online&client_id=${this.btcClientId}&redirect_uri=${this.btcLoginVVBase}&response_type=code&state=${this.btcState}`;
    },
  },
  methods: {
    sendToBtcHub() {
      document.location.href = this.btcLogin;
    },
  }
};
